<div id="footer-wrapper">
    <div id="footer" class="container">
        <div id="box1">
            <div class="title">
                <h2>Latest Post</h2>
            </div>
            <ul class="style1">
                <li><a href="#">Semper mod quis eget mi dolore</a></li>
                <li><a href="#">Quam turpis feugiat sit dolor</a></li>
                <li><a href="#">Amet ornare in hendrerit in lectus</a></li>
                <li><a href="#">Consequat etiam lorem phasellus</a></li>
                <li><a href="#">Amet turpis, feugiat et sit amet</a></li>
                <li><a href="#">Semper mod quisturpis nisi</a></li>
            </ul>
        </div>
        <div id="box2">
            <div class="title">
                <h2>Popular Links</h2>
            </div>
            <ul class="style1">
                <li><a href="#">Semper mod quis eget mi dolore</a></li>
                <li><a href="#">Quam turpis feugiat sit dolor</a></li>
                <li><a href="#">Amet ornare in hendrerit in lectus</a></li>
                <li><a href="#">Consequat etiam lorem phasellus</a></li>
                <li><a href="#">Amet turpis, feugiat et sit amet</a></li>
                <li><a href="#">Semper mod quisturpis nisi</a></li>
            </ul>
        </div>
        <div id="box3">
            <div class="title">
                <h2>Follow Us</h2>
            </div>
            <p>Proin eu wisi suscipit nulla suscipit interdum. Aenean lectus lorem, imperdiet magna.</p>
            <ul class="contact">
                <li><a href="#" class="icon icon-twitter"><span>Twitter</span></a></li>
                <li><a href="#" class="icon icon-facebook"><span>Facebook</span></a></li>
                <li><a href="#" class="icon icon-dribbble"><span>Dribbble</span></a></li>
                <li><a href="#" class="icon icon-tumblr"><span>Tumblr</span></a></li>
                <li><a href="#" class="icon icon-rss"><span>Pinterest</span></a></li>
            </ul>
            <a href="#" class="button">Read More</a> 
        </div>
    </div>
</div>